var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "shareholders" },
    [
      _c("Title", {
        attrs: { zhTitle: _vm.pageData.name, enTitle: _vm.pageData.name },
      }),
      _vm.pageData.sseTotal !== ""
        ? _c("div", { staticClass: "quantity" }, [
            _vm.language === "zh"
              ? _c("span", [
                  _vm._v("股东户数：" + _vm._s(_vm.pageData.sseTotal) + "名"),
                ])
              : _vm.language === "en"
              ? _c("span", [
                  _vm._v(
                    "Number of Shareholders：" + _vm._s(_vm.pageData.sseTotal)
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("div", { staticClass: "describe" }, [
        _vm.language === "zh"
          ? _c("span", [
              _vm.periodName === "一季度" || _vm.periodName === "前三季度"
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.jsonData.year) +
                        _vm._s(_vm.periodName) +
                        "前10名股东持股情况"
                    ),
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(_vm.jsonData.year) +
                        _vm._s(_vm.periodName) +
                        "前10名股东持股情况及报告期内增减"
                    ),
                  ]),
            ])
          : _vm.language === "en"
          ? _c("span", [
              _vm.periodNameEng === "Q1" || _vm.periodNameEng === "Q1-Q3"
                ? _c("span", [
                    _vm._v(
                      "Shareholdings of the top 10 shareholders in " +
                        _vm._s(_vm.jsonData.year) +
                        _vm._s(_vm.periodNameEng)
                    ),
                  ])
                : _c("span", [
                    _vm._v(
                      "Shareholdings of the top 10 shareholders in " +
                        _vm._s(_vm.jsonData.year) +
                        _vm._s(_vm.periodNameEng) +
                        " and Changes in the Reporting Period"
                    ),
                  ]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "table" },
          [
            _c("div", { staticClass: "table-row" }, [
              _c("div", { staticClass: "table-cell column1" }),
              _c("div", { staticClass: "table-cell column2" }),
              _c("div", { staticClass: "table-cell column3-th" }, [
                _vm.language === "zh"
                  ? _c("span", [_vm._v("持股")])
                  : _vm.language === "en"
                  ? _c("span", [_vm._v("Shareholding")])
                  : _vm._e(),
              ]),
              _vm.jsonData.period === "year" || _vm.jsonData.period === "half"
                ? _c("div", { staticClass: "table-cell column4-th" }, [
                    _vm.language === "zh"
                      ? _c("span", [_vm._v("报告期内增减")])
                      : _vm.language === "en"
                      ? _c("span", [_vm._v("Changes")])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._l(_vm.pageData.shareholders, function (row, index) {
              return _c("div", { key: index, staticClass: "table-row" }, [
                _c("div", { staticClass: "table-cell column1" }, [
                  index < 9
                    ? _c("span", [_vm._v("0" + _vm._s(index + 1))])
                    : _c("span", [_vm._v(_vm._s(index + 1))]),
                  _vm._v(".\n\t\t\t\t\t\t"),
                  _vm.language === "zh"
                    ? _c("span", [
                        row.shholdername
                          ? _c("span", { attrs: { title: row.shholdername } }, [
                              _vm._v(_vm._s(row.shholdername)),
                            ])
                          : _c("span", [_vm._v(" ")]),
                      ])
                    : _vm.language === "en"
                    ? _c("span", [
                        row.shholdername_eng
                          ? _c(
                              "span",
                              { attrs: { title: row.shholdername_eng } },
                              [_vm._v(_vm._s(row.shholdername_eng))]
                            )
                          : row.shholdername
                          ? _c("span", { attrs: { title: row.shholdername } }, [
                              _vm._v(_vm._s(row.shholdername)),
                            ])
                          : _c("span", [_vm._v(" ")]),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "table-cell column2" }, [
                  row.shholdername
                    ? _c("div", { staticClass: "progress-bar-container" }, [
                        _vm.showBar
                          ? _c(
                              "div",
                              {
                                staticClass: "progress-bar-div",
                                style: { width: row.showValue1 },
                              },
                              [_c("div", { staticClass: "progress-bar" })]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "table-cell column3" }, [
                  row.shholdername
                    ? _c("span", [_vm._v(_vm._s(row.showValue))])
                    : _vm._e(),
                ]),
                _vm.jsonData.period === "year" || _vm.jsonData.period === "half"
                  ? _c("div", { staticClass: "table-cell column4" }, [
                      row.shholdername
                        ? _c("span", [
                            row.wqtb == "new"
                              ? _c("span", { staticClass: "left-text" }, [
                                  _c("img", {
                                    staticClass: "new",
                                    attrs: { src: _vm.newImg },
                                  }),
                                ])
                              : _c("span", { staticClass: "left-text" }, [
                                  _vm._v(_vm._s(row.wqtb) + "%"),
                                ]),
                            row.wqtb * 1 > 0
                              ? _c("img", {
                                  staticClass: "qs",
                                  attrs: { src: _vm.upImg },
                                })
                              : row.wqtb * 1 < 0
                              ? _c("img", {
                                  staticClass: "qs",
                                  attrs: { src: _vm.downImg },
                                })
                              : row.wqtb * 1 == 0
                              ? _c("img", {
                                  staticClass: "qs",
                                  attrs: { src: _vm.cpImg },
                                })
                              : _c("span", [_vm._v("  ")]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }